"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Timeline = /** @class */ (function (_super) {
    __extends(Timeline, _super);
    function Timeline() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Timeline.prototype.render = function () {
        if (this.props.match.params.challenge == "ICASSP2021") {
            return (React.createElement("div", null,
                React.createElement("h1", null, "Timeline "),
                React.createElement("ul", null,
                    React.createElement("li", null, "September 8, 2020: Release of the datasets and scripts for training and testing."),
                    React.createElement("li", null, "October 2, 2020: Blind test set released to participants. "),
                    React.createElement("li", null, "October 9, 2020: Deadline for participants to submit their results for objective and P.808 subjective evaluation on the blind test set."),
                    React.createElement("li", null, "October 16, 2020: Organizers will notify the participants about the results. "),
                    React.createElement("li", null, "October 19, 2020: Regular paper submission deadline for ICASSP 2021. "),
                    React.createElement("li", null, "January 22, 2021: Paper acceptance/rejection notification. "),
                    React.createElement("li", null, "January 25, 2021: Notification of the winners with winner instructions, including a prize claim deadline."))));
        }
        else {
            return (React.createElement("div", null,
                React.createElement("h1", null, "Timeline "),
                React.createElement("ul", null,
                    React.createElement("li", null, "January 20th, 2020: Release of the datasets and scripts for training and testing. "),
                    React.createElement("li", null, "March 30th, 2020: Complimentary P.808 Subjective evaluation."),
                    React.createElement("li", null, "April 22nd, 2020: Release of the blind test set."),
                    React.createElement("li", null, "April 27th, 2020: Deadline for participants to submit their enhanced clips for P.808 evaluation on the blind test set."),
                    React.createElement("li", null, "May 4th, 2020: Organizers will notify the participants about the results."),
                    React.createElement("li", null, "May 8th, 2020: Regular paper submission deadline for Interspeech 2020."),
                    React.createElement("li", null, "July 24th, 2020: Paper acceptance/rejection notification"),
                    React.createElement("li", null, "July 31st, 2020: Notification of the winners with winner instructions, including a prize claim deadline."))));
        }
    };
    return Timeline;
}(React.Component));
exports.default = react_redux_1.connect()(Timeline);
//# sourceMappingURL=Timeline.js.map